/** Shown when a company assessment is paused (v1 /Survey-Pause compatibility). */
export default function SurveyPausePage() {
  return (
    <section className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-white">
      <div className="max-w-lg">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-50 border border-amber-100 mb-6">
          <svg
            className="w-8 h-8 text-amber-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <p className="text-lg md:text-2xl font-bold text-gray-900 leading-snug">
          This assessment is now closed. Please contact your administrator if
          there are questions.
        </p>
      </div>
    </section>
  );
}
